import React from 'react';
import useStyle from './productInfo.style';
import { ProductDetails } from '../../../../types/product/product';
import { HeaderText } from '../../../atoms/Texts/HeaderText';
import emojis from '../../../../theme/emoji';
import { FeatureContainer } from '../../../molecules/Containers/FeatureContainer';
import { ContainerFullWidth } from 'components/layouts/ContainerFullWidth';
import { ContainerHalf } from '../../../layouts/ContainerHalf';
import { characteristics as characteristicsProducts } from '../../../../helpers/produit/characteristics';

interface ProductInfoBlockProps {
  produit: ProductDetails;
}

export const ProductInfoBlock = ({ produit }: ProductInfoBlockProps) => {
  const classes = useStyle();

  return (
    <ContainerFullWidth>
      <HeaderText text="Informations produit" emoji={emojis['Label']} />
      <ContainerHalf
        col1={
          <FeatureContainer>
            <h3>Liste des ingrédients</h3>
            <ul className={classes.list}>
              {produit.ingredients &&
                produit.ingredients.map(ingredient => (
                  <li className={classes.ingredient} key={ingredient.id}>
                    {ingredient.name}
                  </li>
                ))}
              {produit.allergens &&
                produit.allergens.map(allergen => (
                  <li key={allergen.id}>
                    {allergen.name}{' '}
                    <span role="img" aria-label="emoji">
                      ⛔️
                    </span>
                  </li>
                ))}
            </ul>
            <p className={classes.caption}>
              * Les lignes avec la mention{' '}
              <span className={classes.emoji} role="img" aria-label="emoji">
                ⛔️
              </span>{' '}
              sont les allergènes
            </p>
          </FeatureContainer>
        }
        col2={
          <FeatureContainer>
            <h3>Caractéristiques</h3>
            <ul className={classes.list}>
              {produit.characteristics &&
                produit.characteristics.map(characteristic => (
                  <li className={classes.ingredient} key={characteristic.id}>
                    {characteristicsProducts[characteristic.characteristic]} :{' '}
                    {characteristic.value}
                  </li>
                ))}
            </ul>
          </FeatureContainer>
        }
      />
    </ContainerFullWidth>
  );
};
